import { Organization } from '@shared/types/organization';

// Helper function to get organization thumbnail
export const getOrganizationThumbnail = (
  organization: Organization,
  fallbackText: string
) => {
  if (organization.logoThumbnailUrl || organization.logoUrl) {
    return organization.logoThumbnailUrl || organization.logoUrl;
  }

  // Return a placeholder with organization initials
  return `https://ui-avatars.com/api/?name=${encodeURIComponent(
    fallbackText
  )}&background=random&color=fff&size=128`;
};

export const getOrganizationLogo = (organization: Organization) => {
  if (organization.logoUrl) {
    return organization.logoUrl || organization.logoThumbnailUrl;
  }

  // Return a placeholder with organization initials
  return `https://ui-avatars.com/api/?name=${encodeURIComponent(
    organization.name
  )}&background=random&color=fff&size=128`;
};
